var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "7px",
    viewBox: "0 0 11 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Navigation/chevron/down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-store",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "[Pre-submission]-Configure_certifications-consumer-in-progress",
    transform: "translate(-1399.000000, -536.000000)",
    fill: "#6E6E6E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section-title",
    transform: "translate(263.133056, 525.049503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation/chevron/down",
    transform: "translate(1133.366944, 6.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.09779549,4.78204368 L8.00017673,8.5317995 L11.9007203,4.78383601 C12.0579479,4.62820766 12.2836085,4.62820766 12.4389984,4.78204368 L13.2175107,5.55277083 C13.3719409,5.70565675 13.3719409,5.92609504 13.2175107,6.07898097 L8.3254179,10.8120649 C8.16861505,10.9672837 7.94295445,10.9672837 7.78756453,10.8134477 L2.78003445,6.07626317 C2.62841257,5.92609504 2.62841257,5.70565675 2.78284279,5.55277083 L3.56135506,4.78204368 C3.71674498,4.62820766 3.94240558,4.62820766 4.09779549,4.78204368 Z",
    id: "Path"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-down.5eb9215b8a2593d4351eb5297b0e0666.svg";